import {
	canAccessApplicantAssessment,
	hasApplicantProfile,
	isApplicantAccount
} from '~/utils/userAccountType'

export default async function({ app, store, error }) {
	if (!store.getters['user/user']) {
		await store.dispatch('user/getUser')
	}

	let user = store.getters['user/user'] || {}

	if (isApplicantAccount(user) && !hasApplicantProfile(user)) {
		await store.dispatch('user/getUser', {
			hydrateApplicantProfileFromUser: true
		})
		user = store.getters['user/user'] || {}
	}

	if (!canAccessApplicantAssessment(user)) {
		return error({
			statusCode: 403,
			message:
				app?.i18n?.t('error.candidate-only') ||
					'Access denied: This page is only available to candidates'
		})
	}
}
